"use strict";
// webpack overwrites the isBrowserEnvironment.ts with this file when it creates the browser bundle
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowserEnvironment = void 0;
const isBrowserEnvironment = () => true;
exports.isBrowserEnvironment = isBrowserEnvironment;
//# sourceMappingURL=isBrowserEnvironment_override.js.map